// @flow
import type { GlobalState } from "../../lib/types";

/**
 * Return days om which 'Schedule A Tour' is disabled from the config.
 */
export const getDisabledDays = (state: GlobalState) => {
  return (state.config && state.config.disabledDays) || [];
};
